/**
 * Download the workbook for the version on screen (T3.11).
 *
 * Available to every role that can see the version, a viewer included: export
 * is viewer+ (design.md § 7), and a viewer only ever has a published version on
 * screen. The file is always canonical whatever the client has renamed
 * (design.md § 2.1, boundary 1), which is the API's doing; this button neither
 * knows nor cares.
 *
 * A refusal is shown in place rather than navigating away, and the button is
 * disabled while a request is running so a double click cannot fetch twice.
 */
import { useState } from 'react';
import { ApiError, downloadFile } from '../../lib/api';

export function DownloadButton({
  versionId,
  versionNo,
}: {
  versionId: string;
  versionNo: number;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setBusy(true);
    setError(null);
    try {
      await downloadFile(`/versions/${versionId}/export`, `blueprint-v${versionNo}.xlsx`);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'The download failed. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="bp-action">
      <button type="button" className="btn" onClick={run} disabled={busy}>
        {busy ? 'Preparing…' : 'Download Excel'}
      </button>
      {error ? (
        <span className="bp-inline-err" role="alert">
          {error}
        </span>
      ) : null}
    </span>
  );
}
